import * as icons from "@mui/icons-material";
import { Menu } from "@mui/icons-material";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CustomLink from "components/CustomLink";
import Logo from "components/Logo";
import CustomText from "components/typography/CustomText";
import { useLocation } from "react-router";
import menuData from "./menuData.json";

export default function SideBarContent({ onClick = () => {} }) {
  const location = useLocation();
  return (
    <Box
      role="presentation"
      onClick={onClick}
      onKeyDown={onClick}
      className="flex flex-col h-screen p-2.5 scroll-thumb"
    >
      <div className="mt-2 ml-2">
        <Logo shadow size="small" />
      </div>
      <div className="flex-grow ">
        <List>
          {menuData.map((menuGroup, menuGroupIndex) => (
            <div key={menuGroupIndex}>
              <Divider />
              <CustomText
                className="p-4"
                color="dark-blue"
                font="mont"
                bold={600}
              >
                {menuGroup?.name ?? ""}
              </CustomText>
              {menuGroup?.data?.map((menu, menuIndex) => {
                const TIcon = icons?.[menu?.icon] ?? Menu;
                const isActive = String(location.pathname)
                  .toLocaleLowerCase()
                  .includes(menu.to);
                const textColor = isActive
                  ? "text-secondary"
                  : "text-dark-blue";
                return (
                  <CustomLink
                    key={menuIndex}
                    to={menu?.to ?? "#"}
                    target={menu?.target ?? "_self"}
                  >
                    <ListItem
                      className={`my-2 rounded ${
                        menu?.to === "/bake-dates"
                          ? "bg-primary"
                          : menu?.to === "/weekly-slots"
                          ? "bg-warning"
                          : ""
                      }`}
                      button
                    >
                      <ListItemIcon className="min-w-20">
                        <TIcon
                          className={`${
                            menu?.to === "/bake-dates" ||
                            menu?.to === "/weekly-slots"
                              ? "text-white"
                              : textColor
                          }`}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={menu?.label ?? ""}
                        primaryTypographyProps={{
                          className: `font-semibold ${
                            menu?.to === "/bake-dates" ||
                            menu?.to === "/weekly-slots"
                              ? "text-white"
                              : textColor
                          }`,
                        }}
                      />
                    </ListItem>
                  </CustomLink>
                );
              })}
            </div>
          ))}
        </List>
      </div>
      <div>
        <List>
          <CustomLink to={"/logout"}>
            <ListItem button>
              <ListItemIcon>
                <icons.Logout color="error" />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                primaryTypographyProps={{
                  className: `text-dark-blue font-semibold`,
                }}
              />
            </ListItem>
          </CustomLink>
        </List>
      </div>
    </Box>
  );
}
